import { learningObjectivesIntro, closing } from './AL00000Sprint00'
import { getModuleDescriptionByClassSectionID } from '../DataAndAPIs/ClassSections'
import { sprintEndDateWithoutTime } from '../CalendarAndSchedule/SprintDates'
import { classProductPresentationArchitectureLink } from '../Activities/ClassProduct'

export const al61200Sprint08 = (classSectionID, sprint) => {
	return ( <div>
		<h5>Sprint {sprint}: {getModuleDescriptionByClassSectionID(classSectionID, sprint-1)}</h5>

		{learningObjectivesIntro(sprint)}
		<ul style={{listStyleType:'square'}}>
			<li>Discuss trending architectural styles such microservices and serverless architectures</li>
		</ul>

		{list61200Sprint08(sprint)}
		{closing(sprint)}
	</div> )
}

export const list61200Sprint08 = (sprint) => {
	return ( <div>
		<p>Below is our sprint {sprint} activities list:</p>
		<ol>
			<li>Finalize your {classProductPresentationArchitectureLink()}</li>
			<li>Submit Lab 8 at least two hours prior to your scheduled presentation time</li>
			<li>Deliver your {classProductPresentationArchitectureLink()} jointly with all product teams at the scheduled time</li>
			<li>Submit all assignments no later than {sprintEndDateWithoutTime(sprint-1)}</li>
		</ol>
	</div>)
}